document.addEventListener('DOMContentLoaded', function() {
  // 全ての.tab_btnと.tab_panelを取得
  const tabButtons = document.querySelectorAll('.tab_btn');
  const tabPanels = document.querySelectorAll('.tab_panel');

  tabButtons.forEach((button, index) => {
    button.addEventListener('click', function() {
      // すべての.tab_btnと.tab_panelからactiveクラスを削除
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabPanels.forEach(panel => panel.classList.remove('active'));

      // クリックされた.tab_btnにactiveクラスを付与
      button.classList.add('active');
      // 対応する.tab_panelにactiveクラスを付与
      tabPanels[index].classList.add('active');
    });
  });
});